// export const URL_API = "http://localhost:3005";
export const URL_API = "https://api.flipoeyewear.com";
// ! TEST
export const isDevelopment = false;
